module.exports = __webpack_public_path__ + "static/scale-model-of-henry-vilas-zoo-in-madison-wisconsin-11b99f30aec7d3be9f84ca297d876356.png";